export default {
  requireApproval: false,
  filters: [
    {
      radio: "IsActive", title: "Active Promotions",
      options: [
        {
          fieldName: 'IsActive',
          label: 'Show Active Only',
          value: () => moment().subtract(1, 'year').format('YYYY-MM-DD'),
        }]
    },
    { groupBy: "Status" },
    { groupBy: "VendorLabel", title: "Brand" },
    { date: "dtmStartDate", title: "Start Date" },
    { groupBy: "strPromotionType", title: "Promotion Type" },
    { groupBy: "strRewardType", title: "Reward Type" }
  ],
};
